import DPUCalculator from 'elem/compPage/DPUCalculator';
import PageLayout from '@/components/PageLayout';
import { useGlobal } from '@/utils/useGlobal';
import SEOlinksA from '@/components/SEOlinksA';

export default function DPUCalculatorPage({ SEO }: any) {
    const { useLang, useRouter } = useGlobal();
    const { t } = useLang('dpu_calculator');
    const router = useRouter();
    const { locale } = router;

    if (!['us', 'ca'].includes(locale)) {
        router.push(`/404`);
    }

    return (
        <PageLayout theme={'white'}>
            <SEO title={t('seo_title')} description={t('seo_desc')} />
            <SEOlinksA locale={router.locale} list={['us', 'ca']} pathname={'calculators/delta-pro-ultra'} />
            <DPUCalculator />
        </PageLayout>
    );
}
